import React from 'react';
import ReactDOM from 'react-dom';
import { fetchData } from '../../../../helpers/base_data_fetcher';
import AddressLookup from './components/AddressLookup';
import { getStoredAddress, getInputByName } from './helpers';

/* Mount AddressLookup component */

const elementId: string = 'address_lookup';
const mountElement: HTMLElement | null = document.getElementById(elementId);

// Function to mount the address lookup component
const addressLookupSearch = (settings: any): void => {
  const { allowManualAddress = true } = settings || {};

  if (mountElement) {
    Promise.all([fetchData('page'), fetchData('site')]).then(
      ([pageData, siteData]) => {
        const {
          addressLookupServiceUrl,
          addressLookupServiceKey,
          snippet,
          retainedStreet,
          retainedPostcode,
          showExampleAddress,
        } = mountElement.dataset;

        // Get localisations
        const { post_ad: localisations } = pageData;
        const { country: territory } = siteData;

        // Get address data stored in the session
        let storedAddress = JSON.parse(getStoredAddress());

        // Get values retained by the backend
        if (retainedStreet || retainedPostcode) {
          storedAddress = {
            ...storedAddress,
            line_2: retainedStreet,
            postcode: retainedPostcode,
          };
        }

        const trackingContext =
          pageData.name && pageData.name.includes('wholeproperty')
            ? 'place_whole_property'
            : 'place_room_offered';

        ReactDOM.render(
          <AddressLookup
            alsUrl={addressLookupServiceUrl}
            alsKey={addressLookupServiceKey}
            allowManualAddress={allowManualAddress}
            elementId={elementId}
            localisations={localisations}
            showExampleAddress={showExampleAddress === 'true'}
            storedAddress={storedAddress}
            territory={territory}
            trackingContext={trackingContext}
          />,
          mountElement,
        );

        // Apply validation
        addressLookupValidation();
      },
    );
  }
};

// Function to handle validation in wider context of form
const addressLookupValidation = (): void => {
  const addressId = getInputByName('address_uuid') as HTMLInputElement;
  const form = document.querySelector('.pl_step1') as HTMLFormElement;

  form.addEventListener('submit', (ev) => {
    const input = getInputByName('address_lookup_input') as HTMLInputElement;
    if (input && addressId.value === '') {
      ev.preventDefault();
      input.focus();
    }
  });
};

export default addressLookupSearch;
